<template>
    <div>
        <!-- Date/Schedule 1 -->
        <div class="uk-grid-divider" uk-grid>
            <div class="uk-width-1-4@xl uk-width-1-2@m">
                <div class="uk-grid">
                    <div class="uk-width-1-1@l">
                        <input type="text" class="uk-input uk-width-1-2" name="shift_names[]" placeholder="Shift Name" v-model="shiftDates[0].name" />
                    </div>
                </div>
                <div class="uk-grid uk-margin-remove-top">
                    <div class="uk-width-1-2">
                        <label :for="'shift_start_date' + 0" class="uk-form-label standard-text">Start Date *</label>
                        <datepicker :id="'shift_start_date' + 0" name="shift_start_date[]" @input="startDateSet" @selected="dateSelected(0)"
                                    :value="shiftDates[0].startDate" input-class="uk-input" :use-utc=true :typeable=true
                                    :clear-button=true clear-button-icon="fa fa-times" format="MM/dd/yyyy"></datepicker>
                    </div>
                    <div class="uk-width-1-2">
                        <label :for="'shift_end_date' + 0" class="uk-form-label standard-text">End Date *</label>
                        <datepicker :id="'shift_end_date' + 0" name="shift_end_date[]" @input="endDateSet" @selected="dateSelected(0)"
                                    :value="shiftDates[0].endDate" input-class="uk-input" :use-utc=true :typeable=true
                                    :clear-button=true clear-button-icon="fa fa-times" format="MM/dd/yyyy"></datepicker>
                    </div>
                </div>
            </div>
            <div class="uk-width-1-4@xl uk-width-1-2@m">
                <div class="uk-grid">
                    <div class="uk-width-1-1@l">
                        <label class="uk-form-label">Work Schedule</label>
                    </div>
                </div>
                <div class="uk-grid uk-margin-remove-top">
                    <div class="uk-width-1-2">
                        <label for="shift_time0" class="uk-form-label standard-text">Start Time</label>
                        <time-picker id="shift_time0" name="work_time[]" :value="shiftDates[0].startTime" field-class="uk-input" format="h:mm a" :minute-interval="15"></time-picker>
                    </div>
                    <div class="uk-width-1-2">
                        <label for="work_hours0" class="uk-form-label standard-text">Shift Hours</label>
                        <input type="number" class="uk-input" id="work_hours0" name="work_hours[]" v-model="shiftDates[0].hours" />
                    </div>
                </div>
            </div>
            <div class="uk-width-1-2@xl">
                <div class="uk-grid">
                    <div class="uk-width-2-3">
                        <div class="uk-grid">
                            <div class="uk-width-1-1@l">
                                <label class="uk-form-label">Days of the Week to Work</label>
                            </div>
                        </div>
                        <div class="uk-grid uk-margin-small-top work-days">
                            <div>
                                <label>
                                    <div>All</div>
                                    <input class="uk-checkbox" type="checkbox" name="work_all" v-model="workAll" value="1" />
                                </label>
                            </div>
                            <div>
                                <!-- spacer -->
                            </div>
                            <div>
                                <label>
                                    <div>Mon</div>
                                    <input class="uk-checkbox" type="checkbox" name="work_mon" v-model="workMon" value="1" />
                                </label>
                            </div>
                            <div>
                                <label>
                                    <div>Tue</div>
                                    <input class="uk-checkbox" type="checkbox" name="work_tue" v-model="workTue" value="1" />
                                </label>
                            </div>
                            <div>
                                <label>
                                    <div>Wed</div>
                                    <input class="uk-checkbox" type="checkbox" name="work_wed" v-model="workWed" value="1" />
                                </label>
                            </div>
                            <div>
                                <label>
                                    <div>Thu</div>
                                    <input class="uk-checkbox" type="checkbox" name="work_thu" v-model="workThu" value="1" />
                                </label>
                            </div>
                            <div>
                                <label>
                                    <div>Fri</div>
                                    <input class="uk-checkbox" type="checkbox" name="work_fri" v-model="workFri" value="1" />
                                </label>
                            </div>
                            <div>
                                <label>
                                    <div>Sat</div>
                                    <input class="uk-checkbox" type="checkbox" name="work_sat" v-model="workSat" value="1" />
                                </label>
                            </div>
                            <div>
                                <label>
                                    <div>Sun</div>
                                    <input class="uk-checkbox" type="checkbox" name="work_sun" v-model="workSun" value="1" />
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="uk-width-1-3">
                        <div class="uk-grid">
                            <label for="shifts_per_day" class="uk-form-label standard-text">Shifts Per Day</label>
                            <input type="number" class="uk-input" id="shifts_per_day" name="shifts_per_day" v-model="shiftsPerDay" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Date/Schedules after first -->
        <div class="uk-grid-divider" uk-grid  v-for="(shiftDate, i) in shiftDates" v-if="i > 0 && !shiftDate.removed">
            <div class="uk-width-1-4@xl uk-width-1-2@m">
                <div class="uk-grid">
                    <div class="uk-width-1-1@l">
                        <input type="text" class="uk-input uk-width-1-2" name="shift_names[]" placeholder="Shift Name" v-model="shiftDate.name" />
                    </div>
                </div>
                <div class="uk-grid uk-margin-remove-top">
                    <div class="uk-width-1-2">
                        <label :for="'shift_start_date' + i" class="uk-form-label standard-text">Start Date *</label>
                        <datepicker :id="'shift_start_date' + i" name="shift_start_date[]" @input="startDateSet" @selected="dateSelected(i)"
                                    :value="shiftDate.startDate" input-class="uk-input" :use-utc=true :typeable=true
                                    :clear-button=true clear-button-icon="fa fa-times" format="MM/dd/yyyy"></datepicker>
                    </div>
                    <div class="uk-width-1-2">
                        <label :for="'shift_end_date' + i" class="uk-form-label standard-text">End Date *</label>
                        <datepicker :id="'shift_end_date' + i" name="shift_end_date[]" @input="endDateSet" @selected="dateSelected(i)"
                                    :value="shiftDate.endDate" input-class="uk-input" :use-utc=true :typeable=true
                                    :clear-button=true clear-button-icon="fa fa-times" format="MM/dd/yyyy"></datepicker>
                    </div>
                </div>
            </div>
            <div class="uk-width-1-4@xl uk-width-1-2@m">
                <div class="uk-grid">
                    <div class="uk-width-1-1@l">
                        <label class="uk-form-label">Work Schedule</label>
                    </div>
                </div>
                <div class="uk-grid uk-margin-remove-top">
                    <div class="uk-width-1-2">
                        <label for="shift_time0" class="uk-form-label standard-text">Start Time</label>
                        <time-picker id="shift_time1" name="work_time[]" :value="shiftDate.startTime" field-class="uk-input" format="h:mm a" :minute-interval="15"></time-picker>
                    </div>
                    <div class="uk-width-1-2">
                        <label for="work_hours0" class="uk-form-label standard-text">Shift Hours</label>
                        <input type="number" id="work_hours1" class="uk-input" name="work_hours[]" v-model="shiftDate.hours" />
                    </div>
                </div>
            </div>
        </div>
        <div class="divider thin uk-margin-medium-top uk-margin-medium-bottom"></div>
        <div class="uk-grid">
            <div class="uk-width-1-1@l">
                <label class="uk-form-label">Crafts Requested</label>
            </div>
            <div class="uk-width-1-1@l craft-selection">
                <div class="craft-list uk-margin-medium">
                    <div class="craft-list-row craft-list-header">
                        <div>&nbsp;</div>
                        <div>Craft</div>
                        <div>Shift</div>
                        <div>Specific Date?</div>
                        <div>Specific Training?</div>
                        <div>Specific Cert?</div>
                        <div>Quantity</div>
                        <div>Prevailing Wage/Cert.</div>
                        <div>Union</div>
                        <div>Hourly Wage</div>
                        <div>Individual Travel In/Out</div>
                        <div>Travel In</div>
                        <div>Travel Out</div>
                        <div>Sub Rate</div>
                        <div>Sub Rule</div>
                    </div>
                    <input type="hidden" name="num_jobs" v-model="requestedJobs.length" />
                    <input type="hidden" name="drop_job_ids" v-model="delJobIds" />
                    <div v-for="(reqCraft, i) in requestedJobs" class="craft-list-row">
                        <div>#{{ i+1 }}
                        <input :name="'id_' + i" type="hidden" v-model="reqCraft.id" />
                        </div>
                        <div>
                            <select class="uk-select" :name="'skill_id_' + i" v-model="reqCraft.skillId" @change="updateCraft(i)">
                                <option :value=0 >-- SELECT CRAFT --</option>
                                <option v-for="val in craftOptions" :value="val.id" >{{val.name}}</option>
                            </select>
                        </div>
                        <div>
                            <select class="uk-select" :name="'shift_' + i" v-model="reqCraft.shiftOrder">
                                <option :value=0 >All</option>
                                <option v-for="(sDate, i) in shiftDates" :value="(i+1)" v-if="!sDate.removed" >{{sDate.name}}</option>
                            </select>
                        </div>
                        <div>
                            <input class="uk-checkbox" :name="'specific_date_' + i" type="checkbox" v-model="reqCraft.specificDate" @change="updateCraftDates(i)" />
                        </div>
                        <div>
                            <input class="uk-checkbox" :name="'specific_training_' + i" type="checkbox" v-model="reqCraft.specificTraining" @change="updateCraftTraining(i)" />
                        </div>
                        <div>
                            <input class="uk-checkbox" :name="'specific_cert_' + i" type="checkbox" v-model="reqCraft.specificCert" @change="updateCraftCertification(i)" />
                        </div>
                        <div>
                            <input class="uk-input" :name="'quantity_' + i" type="number" min="1" v-model="reqCraft.quantity" />
                        </div>
                        <div>
                            <input class="uk-checkbox" :name="'prevailing_wage_' + i" type="checkbox" v-model="reqCraft.prevailingWage" />
                        </div>
                        <div>
                            <input class="uk-checkbox" :name="'union_' + i" type="checkbox" v-model="reqCraft.union" />
                        </div>
                        <div>
                            <input class="uk-input" :name="'pay_rate_' + i" type="text" v-model="reqCraft.payRate" />
                        </div>
                        <div>
                            <input class="uk-checkbox" :name="'individual_travel_' + i" type="checkbox" v-model="reqCraft.individualTravel" />
                        </div>
                        <div>
                            <input class="uk-input" :name="'travel_in_' + i" type="number" v-model="reqCraft.travelIn" />
                        </div>
                        <div>
                            <input class="uk-input" :name="'travel_out_' + i" type="number" v-model="reqCraft.travelOut" />
                        </div>
                        <div>
                            <input class="uk-input" :name="'sub_rate_' + i" type="number" v-model="reqCraft.subRate" />
                        </div>
                        <div>
                            <select class="uk-select" :name="'per_diem_type_' + i" v-model="reqCraft.subRule">
                                <option v-for="val in subRuleOptions" :value="val.id" >{{val.name}}</option>
                            </select>
                        </div>
                        <div>
                            <span v-if="!hasNote(reqCraft, i)" class="job-note-icon" @click="loadNotes(reqCraft, i)">
								<img src="/images/note_empty.svg"/>
							</span>
							<span v-if="hasNote(reqCraft, i)" class="job-note-icon active" @click="loadNotes(reqCraft, i)">
								<svg xmlns="http://www.w3.org/2000/svg" width="21.733" height="23.954" viewBox="0 0 21.733 23.954">
								  <g id="Group_1516" data-name="Group 1516" transform="translate(-1332 -1381.001)">
									<path id="Path_109" data-name="Path 109" d="M197.127,358.066c-.021,0-.041.008-.062.009a1.557,1.557,0,0,1,.579.078A1.6,1.6,0,0,0,197.127,358.066Z" transform="translate(1155.055 1027.863)" fill="#004993"/>
									<path id="Path_110" data-name="Path 110" d="M197.062,358.088a1.506,1.506,0,0,0-.266.044l.017.021A1.692,1.692,0,0,1,197.062,358.088Z" transform="translate(1154.899 1027.876)" fill="#004993"/>
									<path id="Path_111" data-name="Path 111" d="M197.664,375.746c.3-.406,1.089-1.2,2.775-3.138.645-.742.489-.595,2.786-7.215l0,0c1.714-4.949,1.741-4.954,1.741-5.254h0a1.522,1.522,0,0,0-2.013-1.63l-.017-.021a1.576,1.576,0,0,0-1.006.982,2.17,2.17,0,0,1,.209-1.679c-.768-.417-.157-.294-13.526-.294a2.365,2.365,0,0,0-2.372,2.356v15.226a2.365,2.365,0,0,0,2.372,2.356H201.02a2.362,2.362,0,0,0,2.356-2.356v-3.259C202.263,372.823,199.33,375.294,197.664,375.746Zm-7.2-2.274a.791.791,0,1,1,0-1.581h7.5l.12,1.581Zm7.855-3.6h-7.855a.791.791,0,1,1,0-1.581h8.4Zm1.246-3.6h-9.1a.791.791,0,1,1,0-1.581c7.226,0,9.393-.006,9.645.008Zm-9.891-4.386a.79.79,0,0,1,.791-.791h8.682a.791.791,0,1,1,0,1.581h-8.682A.79.79,0,0,1,189.678,361.9Z" transform="translate(1148.763 1027.521)" />
    								<circle id="Ellipse_1" data-name="Ellipse 1" cx="5" cy="5" r="5" transform="translate(1332 1381.001)" fill="#31a848"/>
								  </g>
								</svg>
							</span>
                            <i v-if="requestedJobs.length > 1" class="fas fa-times uk-link" @click="dropRow(i)"></i>
                        </div>
                    </div>
                </div>
                <span class="uk-link uk-padding-small" @click="addRequestedCraft"><i class="fas fa-plus-circle"></i> Add Another Craft</span>
            </div>
        </div>
        <div class="divider thin uk-margin-medium-top uk-margin-medium-bottom"></div>
        <div class="uk-grid">
            <div class="uk-width-1-1@s">
                <label class="uk-form-label">General Requisition Training Requirements</label>
            </div>
            <div v-for="train in generalTrainingGroups" class="uk-width-1-4 uk-margin-small">
                <select name="general_training_groups[]" class="uk-select" v-model="train.id">
                    <option value="0">-- Select Training Group --</option>
                    <option v-for="val in trainingGroupOptions" :value="val.id" >**{{val.name}}</option>
                    <option v-for="val in trainingOptions" :value="val.id" >{{val.name}}</option>
                </select>
            </div>
            <div v-for="train in generalTrainings" class="uk-width-1-4 uk-margin-small">
                <select name="general_trainings[]" class="uk-select" v-model="train.id">
                    <option value="0">-- Select Training --</option>
                    <option v-for="val in trainingGroupOptions" :value="val.id" >**{{val.name}}</option>
                    <option v-for="val in trainingOptions" :value="val.id" >{{val.name}}</option>
                </select>
            </div>
            <div class="uk-width-1-1@s">
                <a @click="addGeneralTraining"><i class="fas fa-plus-circle"></i> Add Another General Training Requirement</a>
            </div>
        </div>
        <div v-if="craftTrainingReqs.length > 0" class="uk-grid">
            <div class="uk-width-1-1@s">
                <label class="uk-form-label">Craft-Specific Training Requirements</label>
            </div>
            <div v-for="trainReq in craftTrainingReqs" class="uk-width-1-4 uk-margin-small">
                <label class="uk-form-label standard-text primary-color">#{{ trainReq.index+1 }}: {{ trainReq.craftName }}</label>
                <select class="uk-select" :name="'required_training_' + trainReq.index" v-model="trainReq.trainingId">
                    <option value="0">-- Select Training --</option>
                    <option v-for="val in trainingGroupOptions" :value="val.id" >**{{val.name}}</option>
                    <option v-for="val in trainingOptions" :value="val.id" >{{val.name}}</option>
                </select>
            </div>
        </div>

        <div class="divider thin uk-margin-medium-top uk-margin-medium-bottom"></div>
        <div class="uk-grid">
            <div class="uk-width-1-1@s">
                <label class="uk-form-label">General Requisition Certifications Required</label>
            </div>
            <div v-for="cert in generalCertificationGroups" class="uk-width-1-4 uk-margin-small">
                <select class="uk-select" name="general_certifications[]" v-model="cert.id">
                    <option value="0">-- Select Certification --</option>
                    <option v-for="val in certificationGroupOptions" :value="val.id" >**{{val.name}}</option>
                    <option v-for="val in certificationOptions" :value="val.id" >{{val.name}}</option>
                </select>
            </div>
            <div v-for="cert in generalCertifications" class="uk-width-1-4 uk-margin-small">
                <select class="uk-select" name="general_certifications[]" v-model="cert.id">
                    <option value="0">-- Select Certification --</option>
                    <option v-for="val in certificationGroupOptions" :value="val.id" >**{{val.name}}</option>
                    <option v-for="val in certificationOptions" :value="val.id" >{{val.name}}</option>
                </select>
            </div>
            <div class="uk-width-1-1@s">
                <a @click="addGeneralCertification"><i class="fas fa-plus-circle"></i> Add Another Required General Certification</a>
            </div>
        </div>
        <div v-if="craftCertificationReqs.length > 0" class="uk-grid">
            <div class="uk-width-1-1@s">
                <label class="uk-form-label">Craft-Specific Certification Requirements</label>
            </div>
            <div v-for="certReq in craftCertificationReqs" class="uk-width-1-4 uk-margin-small">
                <label class="uk-form-label standard-text primary-color">#{{ certReq.index+1 }}: {{ certReq.craftName }}</label>
                <select class="uk-select" :name="'required_certification_' + certReq.index" v-model="certReq.certId">
                    <option value="0">-- Select Certification --</option>
                    <option v-for="val in certificationGroupOptions" :value="val.id" >**{{val.name}}</option>
                    <option v-for="val in certificationOptions" :value="val.id" >{{val.name}}</option>
                </select>
            </div>
        </div>
        <div v-if="craftDates.length > 0">
            <div class="divider thin uk-margin-medium-top uk-margin-medium-bottom"></div>
            <div class="uk-grid">
                <div class="uk-width-1-1@s">
                    <label class="uk-form-label">Craft-Specific Active Dates</label>
                </div>
                <div class="uk-grid-divider uk-width-5-6@xl" uk-grid>
                    <div v-for="dates in craftDates" class="uk-width-1-2@l">
                        <div class="uk-grid">
                            <div class="uk-width-1-2 primary-color" style="padding-top: 30px;">
                                #{{ dates.index+1 }}: {{ dates.craftName }}
                            </div>
                            <div class="uk-width-1-4">
                                <label :for="'start_date' + dates.index" class="uk-form-label standard-text primary-color">From:</label>
                                <div class="uk-form-controls">
                                    <datepicker :id="'start_date' + dates.index" :name="'start_date_' + dates.index" :value="dates.startDate" input-class="uk-input" :use-utc=true :typeable=true :clear-button=true clear-button-icon="fa fa-times" format="MM/dd/yyyy"></datepicker>
                                </div>
                            </div>
                            <div class="uk-width-1-4">
                                <label :for="'end_date' + dates.index" class="uk-form-label standard-text primary-color">To:</label>
                                <div class="uk-form-controls">
                                    <datepicker :id="'end_date' + dates.index" :name="'end_date_' + dates.index" :value="dates.endDate" input-class="uk-input" :use-utc=true :typeable=true :clear-button=true clear-button-icon="fa fa-times" format="MM/dd/yyyy"></datepicker>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <input type="hidden" v-for="cache in noteCaches" :name="'job_note_' + cache.index" v-model="cache.content" />
    </div>
</template>

<script>
	import Datepicker from "vuejs-datepicker";
    export default {
        name: "RequisitionCrafts",
		components:{
			Datepicker
		},
        props: {
            rid: {type:Number, default:0}, //requisition ID
            nid: {type:String, default:null} //Note box ID
        },

        data(){
            return {
                minReqJobs: 4,
                requestedJobs:[
                    {
                        id:0,
                        skillId:0,
                        shiftOrder: 0,
                        specificDate:false,
                        specificTraining:false,
                        specificCert:false,
                        quantity:1,
                        prevailingWage:false,
                        union:false,
                        payRate: 0,
                        individualTravel:false,
                        travelIn: 0,
                        travelOut: 0,
                        subRate: 0,
                        subRule:"",
						notes:[]
                    }
                ],
                lostJobs: [],
                generalTrainings:[{id:0}],
                generalCertifications:[{id:0}],
                generalTrainingGroups:[],
                generalCertificationGroups:[],
                craftOptions: [
                    {
                        id: 0,
                        name: ""
                    }
                ],
                trainingOptions: [
                    {
                        id: 0,
                        name: ""
                    }
                ],
                certificationOptions: [
                    {
                        id: 0,
                        name: ""
                    }
                ],
                trainingGroupOptions: [],
                certificationGroupOptions: [],
                craftTrainingReqs:[],
                craftCertificationReqs:[],
                craftDates:[],
                shiftDates:[
                    {
                        name: "Day",
                        startDate: null,
                        endDate: null,
                        removed: false,
                        startTime: '7:00 am',
                        hours: 1
                    }
                ],
                shiftDateSelected: 0,
                subRuleOptions: [
                    {
                        id: "none",
                        name: "None"
                    },
                    {
                        id: "daily",
                        name: "Daily"
                    },
                    {
                        id: "hourly",
                        name: "Hourly"
                    },
                    {
                        id: "7 days",
                        name: "7 Days"
                    },
                    {
                        id: "weekly",
                        name: "Weekly"
                    },
                ],
                craftsLoaded: false,
                trainingsLoaded: false,
                certsLoaded: false,
                trainingGroupsLoaded: false,
                certGroupsLoaded: false,
                deleteIds:[],
                shiftsPerDay: 1,
                workAll: false,
                workMon: false,
                workTue: false,
                workWed: false,
                workThu: false,
                workFri: false,
                workSat: false,
                workSun: false,
                noteCaches: []
            }
        },

        mounted(){
            this.loadCrafts();
            this.loadTrainings();
            this.loadCertifications();
            this.loadTrainingGroups();
            this.loadCertificationGroups();

            while(this.requestedJobs.length < this.minReqJobs){
                this.addRequestedCraft();
            }

            this.loadRequisition();
        },

        methods: {
            loadRequisition(){
                if(this.rid !== 0
                    && this.craftsLoaded
                    && this.trainingsLoaded
                    && this.certsLoaded
                    && this.trainingGroupsLoaded
                    && this.certGroupsLoaded) {
                    axios.get("/api/requisition/get/" + this.rid)
                        .then((pack) => this.updateRequisitionData(pack));
                }
            },
            updateRequisitionData(pack){
                if(pack.data.success){
                    let data = pack.data.data;
                    //populate jobs
                    this.requestedJobs = [];
                    for(let i = 0; i < data.jobRequests.length; ++i){
                        let job = data.jobRequests[i];
                        let requestedJob = {
                            id:job.id,
                            skillId:job.skill_id,
                            shiftOrder: job.date.order,
                            specificDate:job.specific_date,
                            specificTraining:job.specific_training,
                            specificCert:job.specific_cert,
                            quantity:job.quantity,
                            prevailingWage:job.prevailing_wage,
                            union:job.union,
                            payRate: job.pay_rate,
                            individualTravel:job.individual_travel,
                            travelIn: job.travel_in,
                            travelOut: job.travel_out,
                            subRate: job.sub_rate,
                            subRule:job.per_diem_type,
                            notes: job.notes
                        };
                        this.requestedJobs.push(requestedJob);

                        requestedJob.specificDate ? this.addCraftDates(i,
                            job.start_date,
                            job.end_date):null;
                        requestedJob.specificTraining ? this.addCraftTraining(i, job.trainings[0] ? job.trainings[0].id:(job.trainingGroups[0] ? "G" + job.trainingGroups[0].id:0)):null;
                        requestedJob.specificCert ? this.addCraftCertification(i, job.certifications[0] ? job.certifications[0].id:(job.certificationsGroups[0] ? "G" + job.certificationsGroups[0].id:0)):null;

                    }
                    //populate general trainings
                    this.generalTrainings = [];
                    for(let i = 0; i < data.trainings.length;++i){
                        let train = data.trainings[i];
                        this.generalTrainings.push({id:train.id});
                    }
                    //populate general certifications
                    this.generalCertifications = [];
                    for(let i = 0; i < data.certifications.length;++i){
                        let cert = data.certifications[i];
                        this.generalCertifications.push({id:cert.id});
                    }
                    //populate general training groups
                    this.generalTrainingGroups = [];
                    for(let i = 0; i < data.trainingGroups.length;++i){
                        let train = data.trainingGroups[i];
                        this.generalTrainings.push({id:"G"+train.id});
                    }
                    //populate general certification groups
                    this.generalCertificationGroups = [];
                    for(let i = 0; i < data.certificationGroups.length;++i){
                        let cert = data.certificationGroups[i];
                        this.generalCertificationGroups.push({id:"G"+cert.id});
                    }
                    //populate schedule
                    this.shiftDates = [];
                    for(let i = 0; i < data.dates.length; ++i){
                        let date = data.dates[i];
                        if(i == 0){
                            this.workAll = date.work_all;
                            this.workMon = date.work_mon;
                            this.workTue = date.work_tue;
                            this.workWed = date.work_wed;
                            this.workThu = date.work_thu;
                            this.workFri = date.work_fri;
                            this.workSat = date.work_sat;
                            this.workSun = date.work_sun;
                        }

                        this.shiftDates.push(
                            {
                                name: date.name ? date.name:i == 0 ? "Day":i == 1 ? "Night":"Shift " + (i+1),
                                startDate: date.start_date ? date.start_date:data.dates[0].start_date,
                                endDate: date.end_date ? date.end_date:data.dates[0].end_date,
                                removed: false,
                                startTime: date.start_time,
                                hours: date.hours
                            }
                        );
                    }
                    this.shiftsPerDay = this.shiftDates.length;
                    //make sure minimum slots are available
                    this.addGeneralTraining();
                    this.addGeneralCertification();
                    if(this.requestedJobs.length == 0){
                        while(this.requestedJobs.length < this.minReqJobs){
                            this.addRequestedCraft();
                        }
                    }
                }
            },loadCrafts(){
                axios.get("/api/craft/list/all?sort=name&dir=asc")
                    .then((pack) => this.updateCraftData(pack));
            },
            updateCraftData(pack){
                if(pack.data.success) {
                    this.craftOptions = pack.data.data;
                }

                this.craftsLoaded = true;
                this.loadRequisition();
            },
            loadTrainings(){
                axios.get("/api/training/list/all?sort=name&dir=asc&skipGrouped=true").then((pack) => this.updateAvailableTrainings(pack));
            },
            updateAvailableTrainings(pack){
                if(pack.data.success){
                    this.trainingOptions = pack.data.data;
                }
                this.trainingsLoaded = true;
                this.loadRequisition();
            },
            loadCertifications(){
                axios.get("/api/certs/list/all?sort=name&dir=asc&skipGrouped=true").then((pack) => this.updateAvailableCertifications(pack));
            },
            updateAvailableCertifications(pack){
                if(pack.data.success){
                    this.certificationOptions = pack.data.data;
                }
                this.certsLoaded = true;
                this.loadRequisition();
            },
            loadTrainingGroups(){
                axios.get("/api/train-groups/list/all?sort=name&dir=asc").then((pack) => this.updateAvailableTrainingGroups(pack));
            },
            updateAvailableTrainingGroups(pack){
                if(pack.data.success){
                    this.trainingGroupOptions = pack.data.data;
                    //add G to the id to differentiate it as a group
                    for(let i = 0; i < this.trainingGroupOptions.length;++i){
                        this.trainingGroupOptions[i].id = "G" + this.trainingGroupOptions[i].id;
                    }
                }
                this.trainingGroupsLoaded = true;
                this.loadRequisition();
            },
            loadCertificationGroups(){
                axios.get("/api/cert-groups/list/all?sort=name&dir=asc").then((pack) => this.updateAvailableCertificationGroups(pack));
            },
            updateAvailableCertificationGroups(pack){
                if(pack.data.success){
                    this.certificationGroupOptions = pack.data.data;
                    //add G to the id to differentiate it as a group
                    for(let i = 0; i < this.certificationGroupOptions.length;++i){
                        this.certificationGroupOptions[i].id = "G" + this.certificationGroupOptions[i].id;
                    }
                }
                this.certGroupsLoaded = true;
                this.loadRequisition();
            },
            addRequestedCraft(e){
                this.requestedJobs.push({
                    id: 0,
                    skillId:0,
                    shiftOrder: 1,
                    specificDate:false,
                    specificTraining:false,
                    specificCert:false,
                    quantity:1,
                    prevailingWage:false,
                    union:false,
                    payRate: 0,
                    individualTravel:false,
                    travelIn: 0,
                    travelOut: 0,
                    subRate: 0,
                    subRule:"",
					notes:[]
                });
            },
            addGeneralTraining(){
                this.generalTrainings.push({id:0});
            },
            addGeneralCertification(){
                this.generalCertifications.push({id:0});
            },
            getCraftName(id){
                for(let i = 0; i < this.craftOptions.length;++i){
                    if(this.craftOptions[i].id == id){
                        return this.craftOptions[i].name;
                    }
                }
                return "No craft selected";
            },
            getJobById(id){
                for(let i = 0; i < this.requestedJobs.length;++i){
                    if(this.requestedJobs[i].id == id){
                        return this.requestedJobs[i];
                    }
                }

                return null;
            },
            updateCraft(index){
                let craft = this.requestedJobs[index];
                //update trainings
                if(craft.specificTraining) {
                    let foundTraining = false;
                    for (let i = 0; i < this.craftTrainingReqs.length; ++i) {
                        if (this.craftTrainingReqs[i].index == index) {
                            foundTraining = true;
                            this.craftTrainingReqs[i].skillId = craft.skillId;
                            this.craftTrainingReqs[i].craftName = this.getCraftName(craft.skillId);
                            break;
                        }
                    }
                    if (!foundTraining) {
                        this.addCraftTraining(index);
                    }
                }
                //update certifications
                if(craft.specificCert){
                    let foundCert = false;
                    for(let i = 0; i < this.craftCertificationReqs.length;++i){
                        if(this.craftCertificationReqs[i].index == index){
                            foundCert = true;
                            this.craftCertificationReqs[i].skillId = craft.skillId;
                            this.craftCertificationReqs[i].craftName = this.getCraftName(craft.skillId);
                        }
                    }
                    if(!foundCert){
                        this.addCraftCertification(index);
                    }
                }
                //update dates
                if(craft.specificDate){
                    let foundDate = false;
                    for(let i = 0; i < this.craftDates.length;++i){
                        if(this.craftDates[i].index == index){
                            foundDate = true;
                            this.craftDates[i].skillId = craft.skillId;
                            this.craftDates[i].craftName = this.getCraftName(craft.skillId);
                        }
                    }
                    if(!foundDate){
                        this.addCraftDates(index);
                    }
                }
            },
            updateCraftTraining(index){
                let craft = this.requestedJobs[index];
                craft.specificTraining ? this.addCraftTraining(index):this.removeCraftTraining(index);
            },
            addCraftTraining(index, trainingId = 0){
                let craft = this.requestedJobs[index];
                this.craftTrainingReqs.push({
                    index:index,
                    skillId:craft.skillId,
                    craftName:this.getCraftName(craft.skillId),
                    trainingId:trainingId
                });
            },
            removeCraftTraining(index){
                for(let i = 0; i < this.craftTrainingReqs.length;++i){
                    if(this.craftTrainingReqs[i].index == index){
                        this.craftTrainingReqs.splice(i, 1);
                        i--;
                    }
                }
            },
            updateCraftCertification(index){
                let craft = this.requestedJobs[index];
                craft.specificCert ? this.addCraftCertification(index):this.removeCraftCertification(index);
            },
            addCraftCertification(index, certId = 0){
                let craft = this.requestedJobs[index];
                this.craftCertificationReqs.push({
                    index:index,
                    skillId:craft.id,
                    craftName:this.getCraftName(craft.skillId),
                    certId:certId
                });
            },
            removeCraftCertification(index){
                for(let i = 0; i < this.craftCertificationReqs.length;++i){
                    if(this.craftCertificationReqs[i].index == index){
                        this.craftCertificationReqs.splice(i, 1);
                        i--;
                    }
                }
            },
            updateCraftDates(index){
                let craft = this.requestedJobs[index];
                craft.specificDate ? this.addCraftDates(index):this.removeCraftDates(index);
            },
            addCraftDates(index, start = null, end = null){
                let craft = this.requestedJobs[index];
                this.craftDates.push({
                    index:index,
                    skillId: craft.id,
                    craftName: this.getCraftName(craft.skillId),
                    startDate: start,
                    endDate: end
                });
            },
            removeCraftDates(index){
                for(let i = 0; i < this.craftDates.length;++i){
                    if(this.craftDates[i].index == index){
                        this.craftDates.splice(i, 1);
                        i--;
                    }
                }
            },
            dropRow(i){
                let reqJob = this.requestedJobs[i];
                if(reqJob.id != 0){
                    this.deleteIds.push(reqJob.id);
                }
                this.removeCraftCertification(i);
                this.removeCraftTraining(i);
                this.removeCraftDates(i);
                this.requestedJobs.splice(i, 1);
                for(let j = 0; j < this.craftDates.length; ++j){
                    if(this.craftDates[j].index > i){
                        this.craftDates[j].index--;
                    }
                }
                for(let j = 0; j < this.craftCertificationReqs.length; ++j){
                    if(this.craftCertificationReqs[j].index > i){
                        this.craftCertificationReqs[j].index--;
                    }
                }
                for(let j = 0; j < this.craftTrainingReqs.length; ++j){
                    if(this.craftTrainingReqs[j].index > i){
                        this.craftTrainingReqs[j].index--;
                    }
                }
                for(let t = i; t < this.requestedJobs.length;++t){
                    this.updateCraft(t);
                }
            },
            startDateSet(val){
                this.shiftDates[this.shiftDateSelected].startDate = (val.getUTCMonth() + 1) + "/" + val.getUTCDate() + "/" + val.getUTCFullYear();
            },
            endDateSet(val){
                this.shiftDates[this.shiftDateSelected].endDate = (val.getUTCMonth() + 1) + "/" + val.getUTCDate() + "/" + val.getUTCFullYear();
            },
            dateSelected(i){
                this.shiftDateSelected = i;
            },
            loadNotes(craft, index){
                let notes = "";
                if(craft.notes && craft.notes.length > 0){
                    notes = craft.notes[0].content;
                } else { //check note cache for existing note
					for(let i = 0; i < this.noteCaches.length;++i){
						if(this.noteCaches[i].index == index){
							notes = this.noteCaches[i].content;
							break;
						}
					}
				}
                this.$root.$refs[this.nid].loadNotes(notes, craft.id, index, this);
            },
            cacheBack(note, index){
				let found = false;
				for(let i = 0; i < this.noteCaches.length;++i){
					if(this.noteCaches[i].index == index){
						this.noteCaches[i].content = note;
						found = true;
						break;
					}
				}
				if(!found){
					this.noteCaches.push({
						index: index,
						content: note
					});
				}
            },
            updateItem(note, jobId){
                let craft = this.getJobById(jobId);
                if(craft.notes.length < 1){
                    craft.notes.push({
                        content: note
                    });
                } else {
                    craft.notes[0].content = note;
                }
            },
			hasNote(craft, index){
				if(craft.notes && craft.notes.length > 0){
					return true;
				} else {
					for(let i = 0; i < this.noteCaches.length;++i){
						if(this.noteCaches[i].index == index){
							return true;
						}
					}
				}

				return false;
			}
        },

        computed:{
           delJobIds(){
               return this.deleteIds.join(",");
           }
        },

        watch: {
            shiftsPerDay(){
                if(this.shiftsPerDay < 1) {
                    this.shiftsPerDay = 1;
                }

                if(this.shiftDates.length > this.shiftsPerDay) {
                    for(let i = 0; i < this.shiftDates.length; ++i) {
                        if(i < this.shiftsPerDay){
                            this.shiftDates[i].removed = false;
                        } else {
                            this.shiftDates[i].removed = true;
                        }
                    }
                }
                if(this.shiftDates.length <= this.shiftsPerDay) {
                    for(let i = 0; i < this.shiftDates.length; ++i) {
                        this.shiftDates[i].removed = false;
                    }
                    while(this.shiftDates.length < this.shiftsPerDay){
                        this.shiftDates.push({
                            name: this.shiftDates.length == 0 ?
                                "Day":this.shiftDates.length == 1 ? "Night":"Shift " + (this.shiftDates.length + 1),
                            startDate: this.shiftDates[0].startDate,
                            endDate: this.shiftDates[0].endDate,
                            removed: false,
                            startTime: this.shiftDates.length == 0 ? '7:00 am':this.shiftDates.length == 1 ? '6:00 pm':'7:00 am',
                            hours: 1
                        });
                    }
                }

                //check for crafts that have missing shift dates
                for(let i = 0; i < this.requestedJobs.length;++i){
                    let rq = this.requestedJobs[i];
                    if(this.shiftDates[rq.shiftOrder-1].removed){
                        this.lostJobs.push(rq);
                        this.requestedJobs.splice(i, 1);
                        i--;
                    }
                }
                //put back jobs that have been lost, and need to be replaced
                for(let i = 0; i < this.lostJobs.length;++i){
                    let rq = this.lostJobs[i];
                    if(!this.shiftDates[rq.shiftOrder-1].removed){
                        this.requestedJobs.push(rq);
                        this.lostJobs.splice(i, 1);
                        i--;
                    }
                }
            },
            workAll(val){
                if(val){
                    this.workMon = false;
                    this.workTue = false;
                    this.workWed = false;
                    this.workThu = false;
                    this.workFri = false;
                    this.workSat = false;
                    this.workSun = false;
                }
            },
            workMon(val){
                if(val) {
                    this.workAll = false;
                }
            },
            workTue(val){
                if(val) {
                    this.workAll = false;
                }
            },
            workWed(val){
                if(val) {
                    this.workAll = false;
                }
            },
            workThu(val){
                if(val) {
                    this.workAll = false;
                }
            },
            workFri(val){
                if(val) {
                    this.workAll = false;
                }
            },
            workSat(val){
                if(val) {
                    this.workAll = false;
                }
            },
            workSun(val){
                if(val) {
                    this.workAll = false;
                }
            },
        }
    }
</script>
